<template>
  <div class="valuetestonline personalStyle" v-loading="loadingExlel">
    <!-- <navtab class="navtab"></navtab> -->
    <!-- <div class="loginPart" v-if="flag==1">
        <ul class="loginNav">
            <li>登录</li>
        </ul>
        <div class="loginHead">
            <img src="../assets/head.jpg" alt="">
        </div>
        <ul class="loginInput">
            <li><input type="text" placeholder="请输入账号" v-model="loginAdmin"></li>
            <li><input type="password" placeholder="请输入密码" v-model="loginPassword"></li>
        </ul>
        <div class="loginBtn" @click="login()">登    录</div>
    </div>-->
    <div class="loginPart" v-if="flag==1">
      <div class="onlyLef">
        <div class="loginHead">
          <img src="../assets/loginLogo.png" alt />
        </div>
        <!-- <div class="backIndexDiv">
          <img src="../assets/indexback.png" alt />
          <p>返回首页</p>
        </div>-->
      </div>
      <div class="onlyRig">
        <!-- <span class="el-icon-close" id="close" @click="cancelLogin()"></span> -->
        <ul class="loginNav">
          <li>登录</li>
          <!-- <li @click="isRegister()" :class="currentNum==2?'style':''">注册</li> -->
        </ul>
        <ul class="loginInput">
          <li>
            <input type="text" placeholder="请输入手机号码" v-model="loginAdmin" />
          </li>
          <li>
            <input type="password" placeholder="请输入密码" v-model="loginPassword" />
          </li>
        </ul>
        <div class="newDiv">
          <div class="newDivLeft" @click="rememberPw">
            <input type="checkbox" :checked="chooseAll" />
            <p>记住密码</p>
          </div>
          <!-- <span class="forgetPassword" @click="forgetPasswordEvent()">忘记密码？</span> -->
        </div>
        <div class="loginBtn" @click="login()">登 录</div>
        <!-- <p class="newP">
          <span>还未注册，现在就</span>
          <span id="newSpan">注册</span>
        </p>-->
      </div>
    </div>
    <div class="historyFind" v-if="flag==2">
      <!-- <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"> -->
      <!-- <el-menu class="el-menu-demo" mode="horizontal">
        <el-submenu index="2">
          <template slot="title">{{topTitle}}</template>
          <el-menu-item index="2-1" @click="handleCommandTitle(titleFlagone)">电磁阀在线测试查询</el-menu-item>
          <el-menu-item index="2-2" @click="handleCommandTitle(titleFlagtwo)">历史测试查询</el-menu-item>
          <el-submenu index="2-3" @click="handleCommandTitle(titleFlagthree)" id="ahh">
            <template slot="title" id="changeTitleColor" style="font-size:14px">专项测试查询</template>
            <el-menu-item
              id="changeColor"
              v-for="(val,index) in testList"
              :key="index"
              index="2-3-1"
              @click="changeType(val.specialInstructions)"
            >{{val.specialInstructions }}</el-menu-item>
          </el-submenu>
        </el-submenu>
      </el-menu>-->
      <div class="topTitleDiv">
        <div class="topTitleDivLef">电磁阀在线测试查询分类</div>
        <ul class="topTitleDivRig">
          <li
            @click="handleCommandTitle(titleFlagone)"
            :class="dataType==titleFlagone?'colorLi':''"
          >在线测试查询</li>
          <li
            @click="handleCommandTitle(titleFlagtwo)"
            :class="dataType==titleFlagtwo?'colorLi':''"
          >历史测试查询</li>
          <!-- <li
            @click="handleCommandTitle(titleFlagthree)"
            :class="dataType==titleFlagthree?'colorLi':''"
            style="position:relative"
          >
            <el-dropdown style="position:relative">
              <span class="el-dropdown-link">
                专项测试查询
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu class="index-2" slot="dropdown" placement="bottom-end	">
                <el-dropdown-item
                  v-for="(val,index) in testList"
                  :key="index"
                  @click.native="changeType(index)"
                >{{val.specialInstructions }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>-->
          <li
            class="hoves"
            @click="handleCommandTitle(titleFlagthree)"
            :class="dataType==titleFlagthree?'colorLi':''"
          >
            专项测试查询
            <span
              v-show="specialInstructions!=''&&specialInstructions!=null&&specialInstructions!=undefined"
            >——{{specialInstructions}}</span>
            <span class="el-icon-arrow-right"></span>
            <div class="arrowIcon"></div>
            <ul class="bottomUl">
              <li
                v-for="(val,index) in testList"
                :key="index"
                @click.stop="changeType(index)"
              >{{val.specialInstructions}}</li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="line"></div>
      <div id="lineDiv"></div>
      <br />
      <!-- <p class="modelPart">历史测试查询</p> -->
      <!-- <el-dropdown @command="handleCommandTitle">
          <span class="el-dropdown-link">
            <span>{{topTitle}}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(val,index) in titleList" :key="index" :command="index">{{val}}</el-dropdown-item>
          </el-dropdown-menu>
      </el-dropdown>-->
      <div class="sortSearch">
        <!-- <el-dropdown  split-button type="primary" @command="handleCommand">
            时间排序
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">正序</el-dropdown-item>
              <el-dropdown-item command="2">倒序</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>-->
        <div class="search">
          <input type="text" placeholder="请输入关键字" v-model="keywordOne" />
          <div class="searchBtn" @click="search(firstKey)">搜 索</div>
        </div>
      </div>
      <div class="check">
        <p class="checkP">所有分类</p>
        <el-tabs v-model="editableTabsValue2" type="card" closable @tab-remove="removeTab">
          <el-tab-pane
            v-for="(item, index) in editableTabs2"
            :key="index"
            :label="item.title"
            :name="index"
          ></el-tab-pane>
        </el-tabs>
        <p
          class="el-icon-arrow-down arowP arowPa"
          title="点击我试试看！"
          v-show="isClick"
          @click="showBot()"
        ></p>
        <p
          class="el-icon-arrow-up arowP arowPb"
          title="点击我试试看！"
          v-show="!isClick"
          @click="showBot()"
        ></p>
      </div>
      <div class="partPar" v-show="isClick">
        <div class="part">驱动</div>
        <div class="all activeAll" @click="all(qudongFlag)">全部</div>
        <ul class="allUl">
          <li
            class="allUlLi"
            v-for="(val,index) in qudongArr"
            :key="index"
            @click="addTab(val.nameone,qudongFlag,val.sortone)"
          >{{val.nameone}}</li>
        </ul>
      </div>
      <div class="partPar" v-show="isClick">
        <div class="part">控制</div>
        <div class="all activeAll" @click="all(kongzhiFlag)">全部</div>
        <ul class="allUl">
          <li
            class="allUlLi"
            v-for="(val,index) in kongzhiArr"
            :key="index"
            @click="addTab(val.nametwo,kongzhiFlag,val.sorttwo)"
          >{{val.nametwo}}</li>
        </ul>
      </div>
      <div class="partPar" v-show="isClick">
        <div class="part">通位</div>
        <div class="all activeAll" @click="all(tongweiFlag)">全部</div>
        <ul class="allUl">
          <li
            class="allUlLi"
            v-for="(val,index) in tongweiArr"
            :key="index"
            @click="addTab(val.namethree,tongweiFlag,val.sortthree)"
          >{{val.namethree}}</li>
        </ul>
      </div>
      <div class="partPar" v-show="isClick">
        <div class="part">接口</div>
        <div class="all activeAll" @click="all(jiekouFlag)">全部</div>
        <ul class="allUl">
          <li
            class="allUlLi"
            v-for="(val,index) in jiekouArr"
            :key="index"
            @click="addTab(val.namefour,jiekouFlag,val.sortfour)"
          >{{val.namefour}}</li>
        </ul>
      </div>
      <div class="partPar" v-show="isClick">
        <div class="part">型式</div>
        <div class="all activeAll" @click="all(xingshiFlag)">全部</div>
        <ul class="allUl">
          <li
            class="allUlLi"
            v-for="(val,index) in xingshiArr"
            :key="index"
            @click="addTab(val.namefive,xingshiFlag,val.sortfive)"
          >{{val.namefive}}</li>
        </ul>
      </div>
      <div class="partPar" v-show="isClick">
        <div class="part">介质</div>
        <div class="all activeAll" @click="all(jiezhiFlag)">全部</div>
        <ul class="allUl">
          <li
            class="allUlLi"
            v-for="(val,index) in jiezhiArr"
            :key="index"
            @click="addTab(val.namesix,jiezhiFlag,val.sortsix)"
          >{{val.namesix}}</li>
        </ul>
      </div>
      <div class="partPar" v-show="isClick">
        <div class="part">压力</div>
        <div class="all activeAll" @click="all(yaliFlag)">全部</div>
        <ul class="allUl">
          <li
            class="allUlLi"
            v-for="(val,index) in yaliArr"
            :key="index"
            @click="addTab(val.nameseven,yaliFlag,val.sortseven)"
          >{{val.nameseven}}</li>
        </ul>
      </div>
      <div class="partPar" v-show="isClick">
        <div class="part">地区</div>
        <div class="all activeAll" @click="all(diquFlag)">全部</div>
        <ul class="allUl">
          <li
            class="allUlLi"
            v-for="(val,index) in diquArr"
            :key="index"
            @click="addTab(val.nameeight,diquFlag,val.sorteight)"
          >{{val.nameeight}}</li>
        </ul>
      </div>
      <div class="partPar" v-show="isClick">
        <div class="part">结构</div>
        <div class="all activeAll" @click="all(jiegouFlag)">全部</div>
        <ul class="allUl">
          <li
            class="allUlLi"
            v-for="(val,index) in jiegouArr"
            :key="index"
            @click="addTab(val.namenine,jiegouFlag,val.sortnine)"
          >{{val.namenine}}</li>
        </ul>
      </div>
      <div class="dateBox">
        <el-dropdown split-button type="primary" @command="handleCommand">
          时间排序
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">正序</el-dropdown-item>
            <el-dropdown-item command="2">倒序</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="createTimeTitle sortName" @click="sortName()">名称排序</div>
        <div class="createTimeTitle">创建时间</div>
        <div class="block">
          <el-date-picker v-model="value1" type="date" placeholder="开始日期" @change="chageDate"></el-date-picker>
        </div>
        <div class="toto">到</div>
        <div class="block rightBlock">
          <el-date-picker v-model="value2" type="date" placeholder="结束日期" @change="chageDate"></el-date-picker>
        </div>
      </div>
      <div class="table">
        <ul class="tableHead" id="tableHead">
          <li>时间</li>
          <li>名称</li>
          <li>操作</li>
        </ul>
        <ul
          class="tableHead contentUl"
          v-for="(val,index) in tableData"
          :key="index"
          :class="[(index+1)%2==0?'changeBgcColor':'']"
          @click="seeDetail(val.id,val.createTime,val.projectName,index)"
        >
          <li>{{(val.valveName.trim().split(" "))[((val.valveName.trim().split(" ")).length-2)]+' '+(val.valveName.trim().split(" "))[((val.valveName.trim().split(" ")).length-1)]}}</li>
          <li class="textLeft">{{val.projectName}}</li>
          <li class="see" @click="seeDetail(val.id,val.createTime,val.projectName,index)">查看</li>
        </ul>
        <div v-show="tableData.length==0" class="noData">暂无数据</div>
      </div>
      <!-- <el-pagination
            :page-size=showNum
            :current-page="currentPage"
            layout="prev, pager, next"
            @current-change="changePage"
            :total=totalone>
      </el-pagination>-->
      <el-pagination
        background:true
        :page-size="showNum"
        :current-page="currentPage"
        layout="prev, pager, next"
        @current-change="changePage"
        :total="totalone"
      ></el-pagination>
    </div>
    <div class="seeDetail" v-if="flag==3">
      <div class="topBackPart">
        <p class="backP">
          <!-- <span class="el-icon-arrow-left"></span> -->
          <span @click="back()" class="el-icon-arrow-left">返回</span>
        </p>
        <div class="detailTitle">
          <!-- <el-collapse v-model="activeName" accordion>
          <el-collapse-item :title="newTitle" name="1">-->
          <div class="showContPart">
            <div @click="showBottom()">
              <span>{{newTitle}}</span>
              <span class="el-icon-arrow-down arrowSpan"></span>
            </div>
            <div v-show="isShowBottom" class="topArrow"></div>
            <p class="lb" v-show="isShowBottom">电磁阀类别</p>
            <ul class="showCont" v-show="isShowBottom">
              <!-- <template v-for="(val,index) in editableTabs2">
                <li :key="index" v-if="val.title!=''">
                  
                  {{getName(val.name)}}{{val.title}}
                </li>
              </template>-->
              <li>
                <div class="borderRa newC"></div>
                驱动：{{sxObj.drive}}
              </li>
              <li>
                <div class="borderRa"></div>
                控制：{{sxObj.control}}
              </li>
              <li>
                <div class="borderRa newC"></div>
                通位：{{sxObj.positionWay}}
              </li>
              <li>
                <div class="borderRa"></div>
                接口：{{sxObj.port}}
              </li>
              <li>
                <div class="borderRa newC"></div>
                形式：{{sxObj.type}}
              </li>
              <li>
                <div class="borderRa"></div>
                结构：{{sxObj.drive}}
              </li>
              <li>
                <div class="borderRa newC"></div>
                介质：{{sxObj.media}}
              </li>
              <li>
                <div class="borderRa"></div>
                压力：{{sxObj.pressureRating}}
              </li>
              <li>
                <div class="borderRa newC"></div>
                地区：{{sxObj.area}}
              </li>
              <!-- <li v-if="editableTabs2.length==0" style="justify-content:center;width: 100%;">暂无</li> -->
              <!-- <li></li>
              <li></li>-->
            </ul>
            <!-- <p >{{newTitle}}</p><span class="el-icon-arrow-down"></span> -->
            <!-- <p class="showTitle">电磁阀类别</p>
                <ul class="showCont">
                  <template v-for="(val,index) in editableTabs2">
                  <li
                    :key="index"
                    v-if="val.title!=''"
                  ><div :class="(index+1)%2==0?'borderRa#158DD3':'borderRa'"></div> {{getName(val.name)}}{{val.title}}</li></template>
                  <li v-if="editableTabs2.length==0">暂无</li>
                  <li></li>
                  <li></li>
            </ul>-->
          </div>
          <!-- </el-collapse-item>
          </el-collapse>-->
        </div>
      </div>
      <div class="sortSearch">
        <el-dropdown split-button type="primary" @command="handleCommand">
          时间排序
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">正序</el-dropdown-item>
            <el-dropdown-item command="2">倒序</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <div class="outDoc" @click="outExcel()">导出Excel表格</div>   -->
        <div class="outDoc" @click="downloadExcel()">导出Excel表格</div>
        <div class="search">
          <input type="text" placeholder="请输入关键字" v-model="keywordTwo" />
          <div class="searchBtn" @click="search(secondKey)">搜 索</div>
        </div>
      </div>
      <ul class="tabList" v-loading="loading">
        <li
          v-for="(val,index) in tabList"
          :key="index"
          :class="index==0?'timeLi':''||index==1?'sortLi':''"
        >{{val}}</li>
      </ul>
      <div v-show="contList.length==0" class="noData">暂无数据</div>
      <ul
        v-for="(val,index) in contList"
        :key="index"
        class="contList"
        :class="[(index+1)%2==0?'changeDetailBgcColor':'']"
      >
        <li class="timeLi">{{val.testTime}}</li>
        <li class="sortLi">{{val.CycleNumber}}</li>
        <!-- 0无 1正常 2 波形报错 -->
        <li v-show="val.TestCheck==0">无</li>
        <li v-show="val.TestCheck==1">正常</li>
        <li v-show="val.TestCheck==2" id="red">波形报错</li>
        <li>{{val.t1 }}</li>
        <li>{{val.t2}}</li>
        <li>{{val.fq }}</li>
        <li>{{val.pw }}</li>
        <li>{{val.fm}}</li>
        <li>{{val.ph }}</li>
        <li>{{val.uh }}</li>
        <li>{{val.ih }}</li>
        <li>{{val.pp }}</li>
        <li>{{val.up }}</li>
        <li>{{val.ip }}</li>
        <li>{{val.tp }}</li>
        <li>{{val.tc }}</li>
      </ul>
      <el-pagination
        background
        :page-size="showNum"
        :current-page="currentPage"
        layout="prev, pager, next"
        @current-change="changePageDeatil"
        :total="totaltwo"
      ></el-pagination>
    </div>
    <!-- <div v-if="flag==2||flag==3" class="addressDiv" v-html="htmlWord"></div> -->
  </div>
</template>

<script>
import $ from "jquery";
import navtab from "./navtab";
export default {
  name: "valuetestonline",
  components: {
    navtab: navtab
  },
  data() {
    return {
      leftW: "",
      rememberId: "",
      rememberTime: "",
      rememberProjectName: "",
      rememberIdIndex: "",
      isClick: true,
      // htmlWord:
      //   "Copyright&nbsp©&nbsp2016-2019&nbsp浙江桃园科技有限公司&nbsp&nbsp|&nbsp&nbsp 技术支持：杭州互办网络科技有限公司",
      isShowBottom: false,
      chooseAll: true, //true记住密码
      loading: false,
      firstKey: 1,
      secondKey: 2,
      keywordOne: "",
      keywordTwo: "",
      titleFlagone: 0,
      titleFlagtwo: 1,
      titleFlagthree: 2,
      totalone: 1,
      totaltwo: 1,
      titleList: ["在线测试", "历史测试查询", "专项测试查询"],
      loginAdmin: "",
      loginPassword: "",
      flag: 1,
      qudongArr: [
        { nameone: "DC24V", sortone: 0 },
        { nameone: "DC12V", sortone: 1 },
        { nameone: "AC 220V", sortone: 2 },
        { nameone: "AC 110V", sortone: 3 },
        { nameone: "其他", sortone: 4 }
      ],
      kongzhiArr: [
        { nametwo: "单控", sorttwo: 0 },
        { nametwo: "双控", sorttwo: 1 },
        { nametwo: "其他", sorttwo: 2 }
      ],
      tongweiArr: [
        { namethree: "5/2", sortthree: 0 },
        { namethree: "3/2", sortthree: 1 },
        { namethree: "2/2", sortthree: 2 },
        { namethree: "其他", sortthree: 3 }
      ],
      jiekouArr: [
        { namefour: "G1/4", sortfour: 0 },
        { namefour: "G1/8", sortfour: 1 },
        { namefour: "G3/8", sortfour: 2 },
        { namefour: "M5", sortfour: 3 },
        { namefour: "其他", sortfour: 4 }
      ],
      xingshiArr: [
        { namefive: "210", sortfive: 0 },
        { namefive: "110", sortfive: 1 },
        { namefive: "310", sortfive: 2 },
        { namefive: "10mm", sortfive: 3 },
        { namefive: "15mm", sortfive: 4 },
        { namefive: "SY", sortfive: 5 },
        { namefive: "其他", sortfive: 6 }
      ],
      jiezhiArr: [
        { namesix: "压缩空气", sortsix: 0 },
        { namesix: "液压", sortsix: 1 },
        { namesix: "天然气", sortsix: 2 },
        { namesix: "流体", sortsix: 3 },
        { namesix: "真空", sortsix: 4 },
        { namesix: "冷媒", sortsix: 5 },
        { namesix: "其他", sortsix: 6 }
      ],
      yaliArr: [
        { nameseven: "10Bar以下", sortseven: 0 },
        { nameseven: "10~50Bar", sortseven: 1 },
        { nameseven: ">=50Bar", sortseven: 2 }
      ],
      diquArr: [
        { nameeight: "大陆地区", sorteight: 0 },
        { nameeight: "台湾地区", sorteight: 1 },
        { nameeight: "美国", sorteight: 2 },
        { nameeight: "德国", sorteight: 3 },
        { nameeight: "意大利", sorteight: 4 },
        { nameeight: "日本", sorteight: 5 },
        { nameeight: "其他", sorteight: 6 }
      ],
      jiegouArr: [
        { namenine: "先导式", sortnine: 0 },
        { namenine: "直动式", sortnine: 1 },
        { namenine: "其他", sortnine: 2 }
      ],
      editableTabsValue2: "2",
      editableTabs2: [],
      tabIndex: 2,
      // 标签页
      activeName: 1,
      value1: "",
      value2: "",
      tableData: [],
      tabList: [
        "测试时间",
        "次数",
        "波形",
        "T1(ms)",
        "T2(ms)",
        "Fp(Hz)",
        "P(Bar)",
        "Fm(Hz)",
        "Ph(W)",
        "Uh(V)",
        "Ih(mA)",
        "Pp(W)",
        "Up(V)",
        "Ip(mA)",
        "Tp(ms)",
        "Tc(ms)"
      ],
      contList: [2],
      newAdd: "",
      http: "http://192.168.1.240:8080/dcfmain/",
      perInfo: "",
      topTitle: "在线测试查询",
      dataType: 0,
      qudongFlag: "1",
      kongzhiFlag: "2",
      tongweiFlag: "3",
      jiekouFlag: "4",
      xingshiFlag: "5",
      jiezhiFlag: "6",
      yaliFlag: "7",
      diquFlag: "8",
      jiegouFlag: "9",
      drive: "", //驱动（选填） 全部 不传   @"DC 24V" 0,@"DC 12V" 1,@"AC 220V" 2,@"AC 110V" 3,@"其他 4"
      control: "", // 控制 （选填） @"全部",@"单控",@"双控",@"其他"   不传  0  1   2
      positionWay: "", // 通位（选填）
      port: "", // 接口（选填）
      type: "", // 形式（选填）
      structrue: "", // 结构（选填）
      media: "", // 介质（选填）
      pressureRatin: "", // 等级（选填）
      area: "", // 区域（选填）
      currentPage: 1, // 当前第几页（选填）
      pageSize: 60, //每页条数（选填）
      showNum: 60, //每页显示的条数
      currentPage: 1, //当前页码,
      detailid: "",
      testList: [],
      specialInstructions: "",
      data: {
        Id: "", //用户名ID(登录后返回的id 必填)
        dataType: "", //数据类型（0:代表在线测试 1：历史测试查询 2：代表专项测试查询 必填）
        specialInstructions: "", //专项测试（选填 专项测试时必填字段）
        statTime: "", //开始时间(选填)
        endTime: "", //结束时间（选填）
        drive: "", //驱动（选填） 全部 不传   @"DC 24V" 0,@"DC 12V" 1,@"AC 220V" 2,@"AC 110V" 3,@"其他 4"
        control: "", // 控制 （选填） @"全部",@"单控",@"双控",@"其他"   不传  0  1   2
        positionWay: "", // 通位（选填）
        port: "", // 接口（选填）
        type: "", // 形式（选填）
        structrue: "", // 结构（选填）
        media: "", // 介质（选填）
        pressureRatin: "", // 等级（选填）
        area: "", // 区域（选填）
        currentPage: 1, // 当前第几页（选填）
        pageSize: 60 //每页条数（选填）
      },
      time: "",
      sortType: 1,
      newTitle: "",
      resArr: [],
      nameSort: 1,
      sxList: [],
      sxObj: {},
      loadingExlel: false
      // actInd: ""
    };
  },

  methods: {
    downloadExcel() {
      let data = {
        name: this.projectName + this.topTitle,
        map: {
          userId: this.perInfo.id, //用户名ID(登录后返回的id 必填)
          projectId: this.detailid, //数据类型（0:代表在线测试 1：历史测试查询 2：代表专项测试查询 必填）
          statTime: this.value1, //开始时间(选填)
          endTime: this.value2, //结束时间（选填）
          currentPage: this.currentPage,
          pageSize: this.showNum
        }
      };
      this.$axios({
        url: this.$http + "api/daochus/select",
        method: "post",
        cache: false,
        data: JSON.stringify(data),
        contentType: "application/JSON",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(res => {
        //console.log(res);
        if (res.data.code == 0) {
          this.$notify({
            title: "温馨提示",
            message: "已经开始准备为小主下载，快去查收吧！",
            type: "success"
          });
          var url = res.data.msg;
          // window.open(url);会出现空白页面，体验不好
          window.location.href=url;
        }
      });
    },
    outExcel() {
      this.loadingExlel = true;
      // 头部
      // //console.log(this.tabList);
      // 内容
      //console.log(this.resArr);
      //要导出的json数据
      // const jsonData = [
      //   {
      //     name: "路人甲",
      //     phone: "123456789",
      //     email: "000@123456.com"
      //   },
      //   {
      //     name: "炮灰乙",
      //     phone: "123456789",
      //     email: "000@123456.com"
      //   },
      //   {
      //     name: "土匪丙",
      //     phone: "123456789",
      //     email: "000@123456.com"
      //   },
      //   {
      //     name: "流氓丁",
      //     phone: "123456789",
      //     email: "000@123456.com"
      //   }
      // ];
      //列标题，逗号隔开，每一个逗号就是隔开一个单元格
      let str = `测试时间,次数,波形,T1(ms),T2(ms),Fp(Hz),P(Bar),Fm(Hz),Ph(W),Uh(V),Ih(mA),Pp(W),Up(V),Ip(mA),Tp(ms),Tc(ms)\n`;
      //增加\t为了不让表格显示科学计数法或者其他格式
      var newResArr = [];
      for (let i = 0; i < this.resArr.length; i++) {
        // <li v-show="val.TestCheck==0">无</li>
        // <li v-show="val.TestCheck==1">正常</li>
        // <li v-show="val.TestCheck==2" id="red">波形报错</li>
        var stateDesc = "";
        if (this.resArr[i].TestCheck == 0) {
          stateDesc = "无";
        } else if (this.resArr[i].TestCheck == 1) {
          stateDesc = "正常";
        } else if (this.resArr[i].TestCheck == 2) {
          stateDesc = "波形报错";
        }
        var obj = {
          time: this.resArr[i].testTime,
          chishu: this.resArr[i].CycleNumber,
          boxing: stateDesc,
          t1: this.resArr[i].t1,
          t2: this.resArr[i].t2,
          fp: this.resArr[i].fq,
          p: this.resArr[i].pw,
          fm: this.resArr[i].fm,
          ph: this.resArr[i].ph,
          uh: this.resArr[i].uh,
          ih: this.resArr[i].ih,
          pp: this.resArr[i].pp,
          up: this.resArr[i].up,
          ip: this.resArr[i].ip,
          tp: this.resArr[i].tp,
          tc: this.resArr[i].tc
        };
        newResArr.push(obj);
        for (let item in newResArr[i]) {
          str += `${newResArr[i][item] + "\t"},`;
        }
        str += "\n";
        //console.log(str);
        var mm = i + 1;
        if (mm == this.resArr.length) {
          this.loadingExlel = false;
          this.$notify({
            title: "成功",
            message: "导出表格成功，小主快去查收吧！",
            type: "success"
          });
        }
        //console.log(mm, this.resArr.length, mm == this.resArr.length);
      }
      //encodeURIComponent解决中文乱码
      let uri = "data:text/csv;charset=utf-8,\ufeff" + encodeURIComponent(str);
      //通过创建a标签实现
      let link = document.createElement("a");
      link.href = uri;
      //console.log(this.topTitle);
      //对下载的文件命名 this.projectName
      link.download = this.projectName + this.topTitle + ".csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    // 查看详情时的商品属性
    getSpSx(goodid) {
      alert("111");
      //console.log(goodid);
      this.$axios({
        url: this.$http + "/api/Shopping/goodsFormatById/" + goodid,
        method: "get",
        cache: false,
        contentType: "application/JSON",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(res => {
        //console.log(res);
        if (res.data.code == 0) {
          this.sxList = res.data.Entity;
          //console.log(this.sxList);
        }
        // //console.log('这是商品属性'+res);
      });
    },
    showBot() {
      //console.log("0000");
      this.isClick = !this.isClick;
    },
    showBottom() {
      this.isShowBottom = !this.isShowBottom;
    },
    rememberPw() {
      this.chooseAll = !this.chooseAll;
      if (this.chooseAll) {
        // alert("记住密码");
      }
    },
    search(keyFlag) {
      //console.log(keyFlag);
      if (this.flag == 2) {
        if (
          this.keywordOne == "" ||
          this.keywordOne == null ||
          this.keywordOne == undefined
        ) {
          this.$notify({
            title: "温馨提示",
            message: "当前搜索关键字为空，默认显示全部！",
            type: "info"
          });
          // 显示全部
          this.endGet();
        } else {
          this.$notify({
            title: "温馨提示",
            message: "清除搜索关键字，再次点击搜索显示全部！",
            type: "info"
          });
          // 按照关键字筛选
          if (keyFlag == 1) {
            //console.log(this.keywordOne);
            //console.log(this.tableData);
            //字符串方法indexOf
            var arr = [];
            for (var i = 0; i < this.tableData.length; i++) {
              //如果字符串中不包含目标字符会返回-1
              if (this.tableData[i].area.indexOf(this.keywordOne) >= 0) {
                arr.push(this.tableData[i]);
              } else if (
                this.tableData[i].control.indexOf(this.keywordOne) >= 0
              ) {
                arr.push(this.tableData[i]);
              } else if (
                this.tableData[i].createTime.indexOf(this.keywordOne) >= 0
              ) {
                arr.push(this.tableData[i]);
              } else if (
                this.tableData[i].drive.indexOf(this.keywordOne) >= 0
              ) {
                arr.push(this.tableData[i]);
              } else if (this.tableData[i].id.indexOf(this.keywordOne) >= 0) {
                arr.push(this.tableData[i]);
              } else if (
                this.tableData[i].media.indexOf(this.keywordOne) >= 0
              ) {
                arr.push(this.tableData[i]);
              } else if (this.tableData[i].port.indexOf(this.keywordOne) >= 0) {
                arr.push(this.tableData[i]);
              } else if (
                this.tableData[i].positionWay.indexOf(this.keywordOne) >= 0
              ) {
                arr.push(this.tableData[i]);
              } else if (
                this.tableData[i].pressureRating.indexOf(this.keywordOne) >= 0
              ) {
                arr.push(this.tableData[i]);
              } else if (
                this.tableData[i].projectName.indexOf(this.keywordOne) >= 0
              ) {
                arr.push(this.tableData[i]);
              } else if (
                this.tableData[i].structrue.indexOf(this.keywordOne) >= 0
              ) {
                arr.push(this.tableData[i]);
              } else if (this.tableData[i].type.indexOf(this.keywordOne) >= 0) {
                arr.push(this.tableData[i]);
              } else if (
                this.tableData[i].valveName.indexOf(this.keywordOne) >= 0
              ) {
                arr.push(this.tableData[i]);
              }
            }
            // return arr;
            //console.log(arr);
            this.tableData = arr;
            //console.log(this.tableData);
            this.totalone = this.contList.length;
          } else {
            //console.log(this.keywordTwo);
            //console.log(this.contList);
            var arr = [];
            for (var i = 0; i < this.contList.length; i++) {
              //如果字符串中不包含目标字符会返回-1
              if (
                this.contList[i].CycleNumber.toString().indexOf(
                  this.keywordTwo
                ) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].TestCheck.toString().indexOf(
                  this.keywordTwo
                ) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].fm.toString().indexOf(this.keywordTwo) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].fq.toString().indexOf(this.keywordTwo) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].ih.toString().indexOf(this.keywordTwo) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].ip.toString().indexOf(this.keywordTwo) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].ph.toString().indexOf(this.keywordTwo) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].pp.toString().indexOf(this.keywordTwo) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].pw.toString().indexOf(this.keywordTwo) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].t1.toString().indexOf(this.keywordTwo) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].t2.toString().indexOf(this.keywordTwo) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].tc.toString().indexOf(this.keywordTwo) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].testTime.toString().indexOf(this.keywordTwo) >=
                0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].tp.toString().indexOf(this.keywordTwo) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].uh.toString().indexOf(this.keywordTwo) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].up.toString().indexOf(this.keywordTwo) >= 0
              ) {
                arr.push(this.contList[i]);
              }
            }
            // return arr;
            //console.log(arr);
            this.contList = arr;
            //console.log(this.contList);
            this.totaltwo = this.contList.length;
          }
        }
      } else if (this.flag == 3) {
        if (
          this.keywordTwo == "" ||
          this.keywordTwo == null ||
          this.keywordTwo == undefined
        ) {
          this.$notify({
            title: "温馨提示",
            message: "当前搜索关键字为空，默认显示全部！",
            type: "info"
          });
          this.seeDetail(
            this.rememberId,
            this.rememberTime,
            this.rememberProjectName,
            this.rememberIdIndex
          );
          // this.rememberId=id;
          // this.rememberTime=time;
          // this.rememberProjectName=projectName;
          // this.rememberIdIndex=index;
        } else {
          this.$notify({
            title: "温馨提示",
            message: "清除搜索关键字，再次点击搜索显示全部！",
            type: "info"
          });
          // 按照关键字筛选
          if (keyFlag == 1) {
            //console.log(this.keywordOne);
            //console.log(this.tableData);
            //字符串方法indexOf
            var arr = [];
            for (var i = 0; i < this.tableData.length; i++) {
              //如果字符串中不包含目标字符会返回-1
              if (this.tableData[i].area.indexOf(this.keywordOne) >= 0) {
                arr.push(this.tableData[i]);
              } else if (
                this.tableData[i].control.indexOf(this.keywordOne) >= 0
              ) {
                arr.push(this.tableData[i]);
              } else if (
                this.tableData[i].createTime.indexOf(this.keywordOne) >= 0
              ) {
                arr.push(this.tableData[i]);
              } else if (
                this.tableData[i].drive.indexOf(this.keywordOne) >= 0
              ) {
                arr.push(this.tableData[i]);
              } else if (this.tableData[i].id.indexOf(this.keywordOne) >= 0) {
                arr.push(this.tableData[i]);
              } else if (
                this.tableData[i].media.indexOf(this.keywordOne) >= 0
              ) {
                arr.push(this.tableData[i]);
              } else if (this.tableData[i].port.indexOf(this.keywordOne) >= 0) {
                arr.push(this.tableData[i]);
              } else if (
                this.tableData[i].positionWay.indexOf(this.keywordOne) >= 0
              ) {
                arr.push(this.tableData[i]);
              } else if (
                this.tableData[i].pressureRating.indexOf(this.keywordOne) >= 0
              ) {
                arr.push(this.tableData[i]);
              } else if (
                this.tableData[i].projectName.indexOf(this.keywordOne) >= 0
              ) {
                arr.push(this.tableData[i]);
              } else if (
                this.tableData[i].structrue.indexOf(this.keywordOne) >= 0
              ) {
                arr.push(this.tableData[i]);
              } else if (this.tableData[i].type.indexOf(this.keywordOne) >= 0) {
                arr.push(this.tableData[i]);
              } else if (
                this.tableData[i].valveName.indexOf(this.keywordOne) >= 0
              ) {
                arr.push(this.tableData[i]);
              }
            }
            // return arr;
            //console.log(arr);
            this.tableData = arr;
            //console.log(this.tableData);
            this.totalone = this.contList.length;
          } else {
            //console.log(this.keywordTwo);
            //console.log(this.contList);
            var arr = [];
            for (var i = 0; i < this.contList.length; i++) {
              //如果字符串中不包含目标字符会返回-1
              if (
                this.contList[i].CycleNumber.toString().indexOf(
                  this.keywordTwo
                ) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].TestCheck.toString().indexOf(
                  this.keywordTwo
                ) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].fm.toString().indexOf(this.keywordTwo) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].fq.toString().indexOf(this.keywordTwo) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].ih.toString().indexOf(this.keywordTwo) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].ip.toString().indexOf(this.keywordTwo) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].ph.toString().indexOf(this.keywordTwo) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].pp.toString().indexOf(this.keywordTwo) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].pw.toString().indexOf(this.keywordTwo) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].t1.toString().indexOf(this.keywordTwo) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].t2.toString().indexOf(this.keywordTwo) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].tc.toString().indexOf(this.keywordTwo) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].testTime.toString().indexOf(this.keywordTwo) >=
                0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].tp.toString().indexOf(this.keywordTwo) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].uh.toString().indexOf(this.keywordTwo) >= 0
              ) {
                arr.push(this.contList[i]);
              } else if (
                this.contList[i].up.toString().indexOf(this.keywordTwo) >= 0
              ) {
                arr.push(this.contList[i]);
              }
            }
            // return arr;
            //console.log(arr);
            this.contList = arr;
            //console.log(this.contList);
            this.totaltwo = this.contList.length;
          }
        }
      }
    },
    changeDate(timestamp) {
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      var h = date.getHours() + ":";
      var m = date.getMinutes() + ":";
      var s = date.getSeconds();
      return Y + M + D + h + m + s;
    },
    changeType(index) {
      // this.actInd = index;
      this.dataType = 2;
      // //console.log(
      //   this.titleFlagthree,
      //   this.dataType,
      //   this.titleFlagthree == this.dataType
      // );
      //console.log(index, "changeType事件");
      this.currentPage = 1;
      // //console.log(specialInstructions);
      // this.specialInstructions = specialInstructions;
      this.specialInstructions = this.testList[index].specialInstructions;
      //console.log(this.specialInstructions);
      this.topTitle = "专项测试查询";
      //console.log();
      this.getProInfoList();
    },
    changePageDeatil(currentPage) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      //console.log(this.detailid);
      //console.log(currentPage);
      this.currentPage = currentPage;
      let start = this.showNum * (this.currentPage - 1);
      let end = this.showNum * (this.currentPage - 1) + 60;
      //console.log(start, end);
      this.contList = this.resArr.slice(start, end);
      //console.log(this.contList);
      // for (var i = 0; i < this.contList.length; i++) {
      //   this.contList[i].testTime = this.changeDate(
      //     this.contList[i].testTime.slice(0, 10)
      //   );
      // }
      //console.log(this.contList);
      // this.seeDetail(this.detailid,this.time,this.projectName);
    },
    // 获取测试详情 http://101.37.39.157:8080/dcfmain/dataBaseUserApp/getTestData.do
    //  *  @param userId           用户名ID(登录后返回的ID 必填)
    //  *  @param projectId        项目ID（在线，历史，专项中 工程ID字段）
    //  *  @param statTime         开始时间(选填)
    //  *  @param endTime          结束时间（选填）
    //  *  @param currentPage      当前第几页（选填）
    //  *  @param pageSize         每页个数（选填）
    // seeDetail(val.id,val.createTime,val.projectName)"
    seeDetail(id, time, projectName, index) {
      this.rememberId = id;
      this.rememberTime = time;
      this.rememberProjectName = projectName;
      this.rememberIdIndex = index;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.sxObj = this.tableData[index];
      this.loading = true;
      this.time = time;
      //console.log(this.time);
      this.time = this.changeDate(this.time.substring(0, 10));
      this.projectName = projectName;
      //console.log(this.projectName);
      this.newTitle = this.projectName + "—" + this.time;
      this.currentPage = 1;
      this.detailid = id;
      //console.log(this.editableTabs2);
      //console.log(this.detailid);
      // this.getSpSx(this.detailid);
      this.flag = 3;
      //console.log(id);
      let data = {
        url: this.http + "dataBaseUserApp/getTestData.do",
        type: "post",
        map: {
          userId: this.perInfo.id, //用户名ID(登录后返回的id 必填)
          projectId: id, //数据类型（0:代表在线测试 1：历史测试查询 2：代表专项测试查询 必填）
          statTime: this.value1, //开始时间(选填)
          endTime: this.value2, //结束时间（选填）
          currentPage: this.currentPage,
          pageSize: this.showNum
        }
      };
      this.$axios({
        url: this.$http + "api/Home/urldcf",
        method: "post",
        cache: false,
        data: JSON.stringify(data),
        contentType: "application/JSON",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(res => {
        //console.log(res);
        if (res.data.cont.status == 1) {
          document.body.scrollTop = document.documentElement.scrollTop = 0;
          this.totaltwo = res.data.cont.data.length;
          //console.log(res.data.cont.data);
          // contList
          let start = this.showNum * (this.currentPage - 1);
          let end = this.showNum * this.currentPage;
          //console.log(start, end);
          //console.log(res.data.cont.data.slice(start, end));
          this.resArr = res.data.cont.data;
          for (var i = 0; i < this.resArr.length; i++) {
            this.resArr[i].testTime = this.changeDate(
              this.resArr[i].testTime.slice(0, 10)
            );
          }
          this.contList = res.data.cont.data.slice(start, end);
          //console.log(this.contList);

          //console.log(this.contList);
          this.loading = false;
        } else {
          // alert(res.data.cont.showMessage);
          this.$notify.info({
            title: "消息",
            message: res.data.cont.showMessage
          });
        }
      });
    },
    chageDate() {
      this.currentPage = 1;
      //console.log("111");
      this.getProInfoList();
    },
    // 改变标题
    handleCommandTitle(command) {
      this.specialInstructions = "";
      // this.actInd='';
      this.currentPage = 1;
      //console.log(command);
      this.dataType = command;
      //console.log(this.dataType);
      if (this.dataType == 0) {
        this.topTitle = "在线测试查询";
      } else if (this.dataType == 1) {
        this.topTitle = "历史测试查询";
      } else if (this.dataType == 2) {
        this.topTitle = "专项测试查询";
      }
      this.getProInfoList();
    },
    // 正序倒序
    handleCommand(command) {
      //console.log(this.contList);

      // this.currentPage = 1;
      this.sortType = command;
      // if (command == 1) {
      //   alert("正序");
      // } else {
      //   alert("倒序");
      // }
      // this.getProInfoList();

      //  Date.parse(dateTmp)
      if (this.sortType == 1) {
        // alert("正序");
        this.contList.sort(
          (a, b) =>
            Date.parse(a.testTime.replace(/-/g, "/")) -
            Date.parse(b.testTime.replace(/-/g, "/"))
        );
        this.tableData.sort((a, b) => a.createTime - b.createTime);
        if (this.resArr.length > 0) {
          this.resArr.sort(
            (a, b) =>
              Date.parse(a.testTime.replace(/-/g, "/")) -
              Date.parse(b.testTime.replace(/-/g, "/"))
          );
          this.changePageDeatil(1);
        }
        // return this.tableData;
      } else {
        // alert("倒序");
        this.contList.sort(
          (a, b) =>
            Date.parse(b.testTime.replace(/-/g, "/")) -
            Date.parse(a.testTime.replace(/-/g, "/"))
        );
        this.tableData.sort((a, b) => b.createTime - a.createTime);
        if (this.resArr.length > 0) {
          this.resArr.sort(
            (a, b) =>
              Date.parse(b.testTime.replace(/-/g, "/")) -
              Date.parse(a.testTime.replace(/-/g, "/"))
          );
          this.changePageDeatil(1);
        }
      }
    },
    //按照名称排序
    sortName() {
      //console.log("名称排序");

      if (this.nameSort == 1) {
        this.nameSort = 2;

        this.tableData.sort(function compareFunction(param1, param2) {
          return param1.projectName.localeCompare(param2.projectName, "zh");
        });
      } else {
        this.nameSort = 1;
        this.tableData.sort(function compareFunction(param1, param2) {
          return param2.projectName.localeCompare(param1.projectName, "zh");
        });
      }
      //console.log(this.tableData);
    },
    //折叠面板
    handleChange(val) {
      //console.log(val);
    },
    back() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.currentPage = 1;
      this.flag = 2;
      this.getProInfoList();
    },
    // 标签页
    // 增加新的搜索条件
    addTab(targetName, signFlag, sort) {
      this.currentPage = 1;
      //console.log(targetName, signFlag, sort);
      if (
        $(".all")
          .eq(signFlag - 1)
          .hasClass("activeAll")
      ) {
        $(".all")
          .eq(signFlag - 1)
          .removeClass("activeAll");
      }
      for (
        var i = 0;
        i <
        $(".allUl")
          .eq(signFlag - 1)
          .children().length;
        i++
      ) {
        $(".allUl")
          .eq(signFlag - 1)
          .children()
          .eq(i)
          .removeClass("activeAll");
      }
      $(".allUl")
        .eq(signFlag - 1)
        .children()
        .eq(sort)
        .addClass("activeAll");
      // this.newAdd = targetName;
      // //console.log(this.newAdd);
      // //console.log(targetName, signFlag);
      // //console.log(targetName);
      if (this.editableTabs2.length > 0) {
        for (var i = 0; i < this.editableTabs2.length; i++) {
          // //console.log("222");
          if (this.editableTabs2[i].name == signFlag) {
            if (this.editableTabs2[i].title != targetName) {
              this.editableTabs2[i].title = targetName;
              this.editableTabs2[i].content = sort;
            }
            //console.log(this.editableTabs2);
            break;
          }
        }
        if (i == this.editableTabs2.length) {
          this.editableTabs2.push({
            title: targetName,
            name: signFlag,
            content: sort
          });
          //console.log(this.editableTabs2);
        }
      } else {
        this.editableTabs2.push({
          title: targetName,
          name: signFlag,
          content: sort
        });
        //console.log(this.editableTabs2);
      }
      this.getProInfoList();
    },
    removeTab(targetName) {
      //console.log(this.editableTabs2[targetName]);
      var row = this.editableTabs2[targetName].name;
      var col = this.editableTabs2[targetName].content;
      $(".allUl")
        .eq(row - 1)
        .children()
        .eq(col)
        .removeClass("activeAll");
      $(".all")
        .eq(row - 1)
        .addClass("activeAll");
      this.currentPage = 1;

      this.editableTabs2.splice(targetName, 1);

      this.getProInfoList();
      // this.currentPage = 1;
      // let tabs = this.editableTabs2;
      // let activeName = this.editableTabsValue2;
      // if (activeName === targetName) {
      //   tabs.forEach((tab, index) => {
      //     if (tab.name === targetName) {
      //       let nextTab = tabs[index + 1] || tabs[index - 1];
      //       if (nextTab) {
      //         activeName = nextTab.name;
      //       }
      //     }
      //   });
      // }
      // this.editableTabsValue2 = activeName;
      // this.editableTabs2 = tabs.filter(tab => tab.name !== targetName);
      // //console.log(this.editableTabs2);
      // this.getProInfoList();
    },
    all(rowIndex) {
      // console.log(
      //   !$(".all")
      //     .eq(rowIndex - 1)
      //     .hasClass("activeAll"),
      //   $(".all").eq(rowIndex - 1)
      // );
      if (
        !$(".all")
          .eq(rowIndex - 1)
          .hasClass("activeAll")
      ) {
        $(".all")
          .eq(rowIndex - 1)
          .addClass("activeAll");
      }
      for (
        var i = 0;
        i <
        $(".allUl")
          .eq(rowIndex - 1)
          .children().length;
        i++
      ) {
        $(".allUl")
          .eq(rowIndex - 1)
          .children()
          .eq(i)
          .removeClass("activeAll");
      }
      // if()
      this.currentPage = 1;
      for (var i = 0; i < this.editableTabs2.length; i++) {
        //console.log(i, this.editableTabs2[i].name);
        if (this.editableTabs2[i].name == rowIndex) {
          this.editableTabs2.splice(i, 1);
          //console.log(this.editableTabs2);
        }
      }
      //console.log(this.editableTabs2);
      this.getProInfoList();
    },
    login() {
      let data = {
        url: this.http + "dataBaseUserApp/login.do",
        type: "post",
        map: {
          loginUserName: this.loginAdmin,
          loginPassWord: this.loginPassword
        }
      };
      this.$axios({
        url: this.$http + "api/Home/urldcf",
        method: "post",
        cache: false,
        data: JSON.stringify(data),
        contentType: "application/JSON",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(res => {
        //console.log(res);
        if (res.data.cont.status == 1) {
          if (this.chooseAll) {
            // alert("记住密码");
            var map = {
              loginUserName: this.loginAdmin,
              loginPassWord: this.loginPassword
            };
            localStorage.setItem("findZhPw", JSON.stringify(map));
            //console.log("这是记住的密码" + localStorage.getItem("findZhPw"));
          } else {
            localStorage.setItem("findZhPw", "");
          }
          sessionStorage.setItem(
            "findUserZhPw",
            JSON.stringify(res.data.cont.data)
          );
          //console.log(res);
          this.flag = 2;
          //console.log(this.flag);
          document
            .getElementsByClassName("valuetestonline")[0]
            .classList.remove("personalStyle");
          this.perInfo = res.data.cont.data;
          //console.log(this.perInfo);
          this.getType();
          this.getProInfoList();
        } else {
          // alert(res.data.cont.showMessage);
          this.$notify.info({
            title: "消息",
            message: res.data.cont.showMessage
          });
        }
      });
    },
    // dataBaseUserApp/getData.do
    getProInfoList() {
      this.drive = ""; //驱动（选填） 全部 不传   @"DC 24V" 0,@"DC 12V" 1,@"AC 220V" 2,@"AC 110V" 3,@"其他 4"
      this.control = ""; // 控制 （选填） @"全部",@"单控",@"双控",@"其他"   不传  0  1   2
      this.positionWay = ""; // 通位（选填）
      this.port = ""; // 接口（选填）
      this.type = ""; // 形式（选填）
      this.structrue = ""; // 结构（选填）
      this.media = ""; // 介质（选填）
      this.pressureRatin = ""; // 等级（选填）
      this.area = ""; // 区域（选填）
      //console.log(this.perInfo);
      // title: targetName, 标签名
      // name: signFlag,  行
      // content: sort    列
      // qudongFlag: "1",
      // kongzhiFlag: "2",
      // tongweiFlag: "3",
      // jiekouFlag: "4",
      // xingshiFlag: "5",
      // jiezhiFlag: "6",
      // yaliFlag: "7",
      // diquFlag: "8",
      // jiegouFlag:"9"
      //console.log(this.editableTabs2);
      if (this.editableTabs2.length > 0) {
        //console.log(this.editableTabs2);
        for (var index = 0; index < this.editableTabs2.length; index++) {
          //console.log(index);
          //console.log(this.editableTabs2);
          //console.log(this.editableTabs2[index].name);
          if (this.editableTabs2[index].name == 1) {
            this.drive = this.editableTabs2[index].content;
            //console.log(this.drive);
          } else if (this.editableTabs2[index].name == 2) {
            this.control = this.editableTabs2[index].content;
          } else if (this.editableTabs2[index].name == 3) {
            this.positionWay = this.editableTabs2[index].content;
          } else if (this.editableTabs2[index].name == 4) {
            this.port = this.editableTabs2[index].content;
          } else if (this.editableTabs2[index].name == 5) {
            this.type = this.editableTabs2[index].content;
          } else if (this.editableTabs2[index].name == 6) {
            this.media = this.editableTabs2[index].content;
          } else if (this.editableTabs2[index].name == 7) {
            this.pressureRatin = this.editableTabs2[index].content;
          } else if (this.editableTabs2[index].name == 8) {
            this.area = this.editableTabs2[index].content;
          } else if (this.editableTabs2[index].name == 9) {
            this.structrue = this.editableTabs2[index].content;
          }
          //console.log(index);
          //console.log(this.editableTabs2.length);
          //console.log(this.data);
          //console.log(this.drive);
          if (index == this.editableTabs2.length - 1) {
            this.data = {
              url: this.http + "dataBaseUserApp/getData.do",
              type: "post",
              map: {
                Id: this.perInfo.id, //用户名ID(登录后返回的id 必填)
                dataType: this.dataType, //数据类型（0:代表在线测试 1：历史测试查询 2：代表专项测试查询 必填）
                specialInstructions: this.specialInstructions, //专项测试（选填 专项测试时必填字段）
                statTime: this.value1, //开始时间(选填)
                endTime: this.value2, //结束时间（选填）
                drive: this.drive, //驱动（选填） 全部 不传   @"DC 24V" 0,@"DC 12V" 1,@"AC 220V" 2,@"AC 110V" 3,@"其他 4"
                control: this.control, // 控制 （选填） @"全部",@"单控",@"双控",@"其他"   不传  0  1   2
                positionWay: this.positionWay, // 通位（选填）
                port: this.port, // 接口（选填）
                type: this.type, // 形式（选填）
                structrue: this.structrue, // 结构（选填）
                media: this.media, // 介质（选填）
                pressureRatin: this.pressureRatin, // 等级（选填）
                area: this.area, // 区域（选填）
                currentPage: this.currentPage, // 当前第几页（选填）
                pageSize: this.showNum //每页条数（选填）
              }
            };
            this.endGet();
          }
        }
      } else {
        this.data = {
          url: this.http + "dataBaseUserApp/getData.do",
          type: "post",
          map: {
            Id: this.perInfo.id, //用户名ID(登录后返回的id 必填)
            dataType: this.dataType, //数据类型（0:代表在线测试 1：历史测试查询 2：代表专项测试查询 必填）
            specialInstructions: this.specialInstructions, //专项测试（选填 专项测试时必填字段）
            statTime: this.value1, //开始时间(选填)
            endTime: this.value2, //结束时间（选填）
            drive: "", //驱动（选填） 全部 不传   @"DC 24V" 0,@"DC 12V" 1,@"AC 220V" 2,@"AC 110V" 3,@"其他 4"
            control: "", // 控制 （选填） @"全部",@"单控",@"双控",@"其他"   不传  0  1   2
            positionWay: "", // 通位（选填）
            port: "", // 接口（选填）
            type: "", // 形式（选填）
            structrue: "", // 结构（选填）
            media: "", // 介质（选填）
            pressureRatin: "", // 等级（选填）
            area: "", // 区域（选填）
            currentPage: 1, // 当前第几页（选填）
            pageSize: this.showNum //每页条数（选填）
          }
        };
        //console.log(this.data);
        this.endGet();
      }
    },
    endGet() {
      //console.log(this.specialInstructions);
      //console.log(this.data);
      this.$axios({
        url: this.$http + "api/Home/urldcf",
        method: "post",
        cache: false,
        data: JSON.stringify(this.data),
        contentType: "application/JSON",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(res => {
        //console.log(res);
        if (res.data.cont.status == 1) {
          this.tableData = [];
          //console.log(res.data.cont.data);
          this.totalone = res.data.cont.data.length;
          let start = this.showNum * (this.currentPage - 1);
          let end = this.showNum * (this.currentPage - 1) + 60;
          //console.log(start, end);
          //console.log(res.data.cont.data.slice(start, end));
          this.tableData = res.data.cont.data.slice(start, end);
          // this.tableData = res.data.cont.data;
          //console.log(this.currentPage);
        } else {
          // alert(res.data.cont.showMessage);
          this.$notify.info({
            title: "消息",
            message: res.data.cont.showMessage
          });
        }
      });
    },
    changePage(currentPage) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      //console.log(currentPage);
      this.currentPage = currentPage;
      this.getProInfoList();
    },
    /**  获取专项测试分类
     *
     *  @param userId           用户名ID(登录后返回的ID 必填)
     *  @param currentPage      当前第几页（选填）
     *  @param pageSize      每页个数（选填）
     URL：http://101.37.39.157:8080/dcfmain/dataBaseUserApp/getSpecialInstructionsType.do */
    getType() {
      let data = {
        url: this.http + "dataBaseUserApp/getSpecialInstructionsType.do",
        type: "post",
        map: {
          userId: this.perInfo.id, //用户名ID(登录后返回的id 必填)
          currentPage: this.currentPage, // 当前第几页（选填）
          pageSize: this.showNum //每页条数（选填）
        }
      };
      this.$axios({
        url: this.$http + "api/Home/urldcf",
        method: "post",
        cache: false,
        data: JSON.stringify(data),
        contentType: "application/JSON",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(res => {
        //console.log(res);
        if (res.data.cont.status == 1) {
          this.testList = res.data.cont.data;
          //console.log(this.testList);
        }
      });
    },

    // 获取显示名字
    getName(index) {
      if (index == 1) {
        return "驱动：";
      } else if (index == 2) {
        return "控制：";
      } else if (index == 3) {
        return "通位：";
      } else if (index == 4) {
        return "接口：";
      } else if (index == 5) {
        return "型式：";
      } else if (index == 6) {
        return "介质：";
      } else if (index == 7) {
        return "压力：";
      } else if (index == 8) {
        return "地区：";
      } else if (index == 9) {
        return "结构：";
      }
    }
  },

  created() {},
  // watch: {
  //   flag: {
  //     handler: function(val, oldval) {
  //       if (val == 2) {
  //         //console.log(val, "变化");
  //         document.getElementsByClassName("index-2").css({
  //           left: this.leftW + "px!important"
  //         });
  //       }
  //     },
  //     deep: true
  //   }
  // },
  mounted() {
    // //console.log(split-button);

    this.leftW =
      document.body.clientWidth * 0.2 +
      document.body.clientWidth * 0.8 * 0.7 * 0.1 +
      154 +
      30 +
      (84 + 50) * 2 +
      131;
    //console.log(this.leftW);
    //console.log(localStorage.getItem("findZhPw"));
    if (localStorage.getItem("findZhPw")) {
      //console.log("已经存在被记住的密码");
      //console.log(JSON.parse(localStorage.getItem("findZhPw")));
      //console.log(
      //   JSON.parse(localStorage.getItem("findZhPw")).loginUserName,
      //   JSON.parse(localStorage.getItem("findZhPw")).loginPassWord
      // );
      this.loginAdmin = JSON.parse(
        localStorage.getItem("findZhPw")
      ).loginUserName;
      this.loginPassword = JSON.parse(
        localStorage.getItem("findZhPw")
      ).loginPassWord;
      //       loginUserName: this.loginAdmin,
      // loginPassWord: this.loginPassword
    }
    if (sessionStorage.getItem("findUserZhPw")) {
      document
        .getElementsByClassName("valuetestonline")[0]
        .classList.remove("personalStyle");
      this.perInfo = JSON.parse(sessionStorage.getItem("findUserZhPw"));
      //console.log(this.perInfo);
      this.getType();
      this.getProInfoList();
      this.flag = 2;
      //console.log(this.flag);
    }
  }
  // watch  flag==2
  // watch: {
  //   flag: {
  //     handler: function(val, oldval) {
  //       if(val==2){
  //         alert('val==2');
  //         //console.log(document.getElementsByClassName('el-dropdown-menu'));
  //         document.getElementsByClassName('el-dropdown-menu').cssText="left: 1200px!important;"
  //       }else{
  //         alert('val!=2');
  //          //console.log(document.getElementsByClassName('el-dropdown-menu'));
  //         document.getElementsByClassName('el-dropdown-menu').cssText="left: 0px!important;"
  //       }

  //     },
  //     deep: true
  //   }
  // }
};
</script>

<style>
.contentUl {
  cursor: pointer;
}
.sortName {
  cursor: pointer;
}
.arowP {
  height: 40px;
  line-height: 40px;
  position: relative;
  right: 0;
  /* background-color: pink; */
  /* top: 50%;
  transform: translateY(-50%); */
  margin-left: 30px;
  cursor: pointer;
}
.arowPa,
.arowPb {
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #666;
}
.topArrow {
  width: 12px;
  height: 12px;
  background-color: #fff;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  /* bottom:  */
  /* border-color: transparent #158DD3 transparent transparent; */
  transform: rotate(45deg); /*顺时针旋转90°*/
  bottom: -7px;
  z-index: 99999;
}
.arrowSpan {
  margin-left: 10px;
}
.borderRa {
  width: 12px;
  height: 12px;
  background-color: #ffba00;
  border-radius: 50%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  margin-right: 10px;
}
.borderRa#158DD3 {
  width: 12px;
  height: 12px;
  background-color: #158dd3;
  border-radius: 50%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  margin-right: 10px;
}
#newSpan {
  color: #158dd3;
}
.backIndexDiv {
  position: absolute;
  left: 30px;
  bottom: -36px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  cursor: pointer;
}
.backIndexDiv img {
  display: block;
  height: 23px;
  width: 23px;
}
.backIndexDiv p {
  font-size: 16px;
  font-family: MicrosoftYaHei;
  font-weight: bold;
  color: #158dd3;
  margin-left: 10px;
}
.el-collapse-item__arrow {
  margin: 0 8px 0px 5px;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  color: #fff !important;
  background-color: #158dd3 !important;
}
.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  background-color: #ffffff !important;
  color: #158dd3 !important;
  min-width: 30px;
  border-radius: 2px;
  border: 1px solid #158dd3 !important;
}
.changeBgcColor {
  background: rgba(158, 169, 208, 0.06);
}
.createTimeTitle {
  height: 40px;
  line-height: 40px;
  font-weight: 600;
  font-size: 14px;
  margin-right: 2%;
}
.el-button--primary {
  color: #158dd3 !important;
}
.toto {
  height: 40px;
  line-height: 40px;
  font-weight: 600;
  font-size: 12px;
  margin-left: 1%;
  color: #158dd3;
}
.el-menu--horizontal > .el-submenu .el-submenu__title {
  color: black;
}
#red {
  color: #158dd3;
  /* background-color: #fdeef1; */
}
#ahh {
  font-size: 12px !important;
  color: #158dd3 !important;
}
#changeTitleColor {
  color: #158dd3 !important;
  font-size: 12px !important;
}
#changeColor {
  color: gray !important;
  font-size: 12px !important;
}
#changeColor:hover {
  color: black !important;
}
.el-submenu.is-active .el-submenu__title {
  border: 0 !important;
}
.el-menu.el-menu--horizontal {
  border-bottom: solid 1px #fff;
  /* background-color: pink; */
  /* width: 10%; */
  margin: 0 auto;
}
.el-dropdown-link {
  cursor: pointer;
  color: #000;
  font-size: 15px;
  display: block;
  margin: 16px auto !important;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.valuetestonline {
  background-color: #f1f1f1;
}
.personalStyle {
  min-height: 100vh;
  /* background-image: url("../assets/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%; */
  background-color: rgba(231, 240, 255, 1);
}
.valuetestonline .loginPart {
  background-image: url("../assets/loginbj.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 900px;
  /* height: 38%; */
  /* background: #fff; */
  border-radius: 30px;
  /* margin: 0 auto;
  margin-top: 5%; */
  position: absolute;
  top: 23%;
  left: 50%;
  transform: translate(-50%, 0%) scale(0.7);
  z-index: 10;
  padding: 0 0;
  padding-bottom: 4%;
  /* position: relative; */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
#close {
  width: 26px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  font-size: 18px;
  color: #fff;
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  /* background-color: pink; */
  cursor: pointer;
  border-radius: 50%;
  border: 2px solid #ccc;
  overflow: hidden;
}
.valuetestonline .loginPart .loginHead {
  height: 360px;
  width: 360px;
  overflow: hidden;
  border-radius: 50%;
  margin: 20px auto;
  /* border: 1px solid #b5b4b4; */
  /* margin-bottom: 20px; */
  text-align: center;
  /* line-height: 50px; */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.valuetestonline .loginPart .loginHead img {
  display: block;
  width: 100%;
  height: 100%;
}
.valuetestonline .loginPart .loginNav {
  width: 100%;
  height: 50px;
  line-height: 50px;
  color: black;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.valuetestonline .loginPart .loginNav li {
  height: 86%;
  cursor: pointer;
  text-align: center;
  /* width: 52px; */
  /* width: 100%; */
  font-size: 16px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  margin: 0 10%;
  font-size: 20px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
}
.valuetestonline .loginPart .loginInput {
  width: 80%;
  margin: 0 auto;
}
.valuetestonline .loginPart .loginInput li {
  height: 48px;
  /* background: black; */
  margin: 12% 0;
  border: 1px solid #b5b4b4;
  border-radius: 24px;
  padding: 0 22px;
}
.valuetestonline .loginPart .loginInput li input {
  padding-left: 3px;
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: 0;
  color: rgb(32, 32, 32);
  outline: none;
  font-size: 14px;
  /* 控制文字之间的间距 */
  letter-spacing: 1px;
}
.valuetestonline .loginPart .loginInput li input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #b5b4b4;
}

.valuetestonline .loginPart .loginInput li input:-moz-placeholder,
textarea:-moz-placeholder {
  color: #b5b4b4;
}

.valuetestonline .loginPart .loginInput li input::-moz-placeholder,
textarea::-moz-placeholder {
  color: #b5b4b4;
}

.valuetestonline .loginPart .loginInput li input:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  color: #b5b4b4;
}
.valuetestonline .loginPart .forgetPassword {
  display: block;
  text-align: right;
  width: 150px;
  /* width: 200px; */
  height: 15px;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: #158dd3;
  /* margin-left: 60%; */
  /* margin-top: 6%; */
  cursor: pointer;
}
.valuetestonline .loginPart .loginBtn {
  width: 80%;
  height: 50px;
  text-align: center;
  line-height: 50px;
  color: rgba(255, 255, 255, 1);
  background: #158dd3;
  margin: 0 auto;
  margin-top: 5%;
  border-radius: 25px;
  cursor: pointer;
  font-size: 15px;
  margin-bottom: 20px;
}
.el-tabs__item.is-active {
  color: #158dd3;
}
html {
  background-color: #fff;
}
.el-collapse {
  border-top: 0;
}
.block {
  cursor: pointer;
}
.aaa {
  cursor: pointer !important;
}
/* .el-table__body-wrapper,
.el-table__footer-wrapper, */
.el-table__header-wrapper {
  width: 80% !important;
  margin: 0 auto !important;
}
.valuetestonline .navtab {
  box-shadow: 0px 4px 8px 0px rgba(102, 102, 102, 0.2);
  z-index: 999;
}
.valuetestonline .historyFind {
  width: 80%;
  margin: 20px auto;
  margin-bottom: 0;
  background-color: #fff;
  padding-bottom: 1%;
  padding-top: 30px;
}
.valuetestonline .historyFind .table {
  width: 80%;
  margin: 0 auto;
  margin-bottom: 1%;
  margin-top: 15px;
}
#tableHead {
  background-color: #158dd3;
}
#tableHead li {
  color: #fff !important;
}
.valuetestonline .historyFind .table .tableHead {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.valuetestonline .historyFind .table .tableHead .see {
  cursor: pointer;
  color: #158dd3;
}
.valuetestonline .historyFind .table .tableHead .see:hover {
  color: #158dd3;
}
.valuetestonline .historyFind .table .tableHead li {
  height: 50px;
  width: 33.3%;
  text-align: left;
  font-size: 12px;
  line-height: 50px;
  color: black;
  padding-left: 50px;
}
.valuetestonline .historyFind .table .tableHead:hover {
  background-color: rgba(53, 124, 250, 0.1);
}
.valuetestonline .historyFind .modelPart {
  font-size: 16px;
  line-height: 30px;
  color: black;
  text-align: center;
  width: 88%;
  margin: 1% auto;
}
.valuetestonline .historyFind .sortSearch {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-left: 10%;
}
.valuetestonline .historyFind .sortSearch .search {
  height: 40px;
  width: 40%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  /* margin-left: 30px; */
}
.valuetestonline .el-dropdown .el-button-group {
  display: block;
  margin-right: 20px;
  font-size: 14px !important;
}
.valuetestonline .historyFind .sortSearch .search input {
  outline: none;
  border: 1px solid #ccc;
  text-align: left;
  padding-left: 10px;
  width: 80%;
  color: #8a8a8a;
  border-radius: 3px 0 0 3px;
  font-size: 14px;
}
.valuetestonline .historyFind .sortSearch .search .searchBtn {
  height: 40px;
  width: 16%;
  line-height: 40px;
  background-color: #158dd3;
  text-align: center;
  color: #fff;
  font-size: 14px;
}
.outDoc {
  height: 40px;
  /* width: 16%; */
  padding: 0 20px;
  line-height: 40px;
  background-color: #158dd3;
  text-align: center;
  color: #fff;
  font-size: 14px;
  margin-left: 30px;
  cursor: pointer;
}
.searchBtn {
  cursor: pointer;
}
.valuetestonline .historyFind .check {
  width: 70%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  /* margin: 1% 0; */
  margin-left: 10%;
  margin-top: 20px;
  border-bottom: 1px solid #f1f1f1;
}
.valuetestonline .historyFind .check .checkP {
  font-size: 14px;
  color: black;
  margin-right: 1%;
  text-align: left;
  height: 40px;
  line-height: 40px;
}
.valuetestonline .historyFind .check .checkKeyUl {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  border: 1px solid #ccc;
  padding: 0 10px;
  line-height: 30px;
}
.valuetestonline .historyFind .check .checkKeyUl .checkKeyUlLi {
  color: #ccc;
  height: 30px;
  line-height: 30px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin: 0 5px;
  cursor: pointer;
}
.valuetestonline .historyFind .check .checkKeyUl .checkKeyUlLi .close {
  margin-left: 10%;
  white-space: nowrap;
}
.valuetestonline .historyFind .check .checkKeyUl .checkKeyUlLi .close:hover {
  color: #158dd3 !important;
}
.valuetestonline
  .historyFind
  .check
  .checkKeyUl
  .checkKeyUlLi
  .checkKeyUlLiCont {
  min-width: 70px;
}
.valuetestonline .historyFind .check .checkKeyUl .checkKeyUlLi span {
  color: #928484;
  height: 30px;
  line-height: 30px;
}
.valuetestonline .historyFind .dateBox {
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  margin-left: 10%;
  width: 80%;
  background: #eaf2fe;
  color: #158dd3;
  margin-top: 10px;
  box-shadow: 0px 9px 20px 0px rgba(92, 92, 92, 0.1);
}
.valuetestonline .historyFind .dateBox .rightBlock {
  margin-left: 1%;
}
.valuetestonline .historyFind .partPar {
  width: 80%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-left: 10%;
  line-height: 30px;
  border-bottom: 1px dotted #f1f1f1;
}
.valuetestonline .historyFind .partPar .part {
  font-weight: 600;
  font-size: 14px;
  margin-right: 50px;
}
.valuetestonline .historyFind .partPar .all {
  margin: 0 1%;
  cursor: pointer;
  font-size: 14px;
}
.valuetestonline .historyFind .partPar .all:hover {
  color: #158dd3; /* font-weight: 600; */
  padding: 0 20px;
}
/* .activeAll {
  color: #158DD3;
} */
.activeLi {
  color: #158dd3;
}
.valuetestonline .historyFind .partPar .allUl {
  width: 80%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  font-size: 14px;
}
.valuetestonline .historyFind .partPar .allUl .allUlLi {
  margin: 0 23px;
  line-height: 30px;
  cursor: pointer;
}
.valuetestonline .historyFind .partPar .allUl .allUlLi:hover {
  /* color: #158DD3; */
  color: #158dd3;
  /* font-weight: 600; */
  padding: 0 20px;
}
.valuetestonline .seeDetail {
  width: 100%;
  margin: 0 auto;
  /* background-color: #fafafa; */
  margin-top: 1%;
}
.valuetestonline .seeDetail .topBackPart {
  width: 80%;
  height: 10%;
  margin: 0 auto;
  background-color: #fff;
  position: relative;
  height: 66px;
  padding: 0 20px;
  border-bottom: 1px solid #f1f1f1;
}
.valuetestonline .seeDetail .topBackPart .backP {
  position: absolute;
  /* left: 2%; */
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #737272;
  font-size: 14px;
}
.valuetestonline .seeDetail .topBackPart .backP:hover {
  /* border-bottom: 2px solid #158DD3; */
  padding-bottom: 3px;
  color: #158dd3;
}
.valuetestonline .seeDetail .topBackPart .detailTitle {
  /* width: 16%; */
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translateX(-50%);
  transform: translate(-50%, -50%);
  height: 67px;
  line-height: 67px;
}
.valuetestonline .seeDetail .topBackPart .detailTitle .showContPart {
  width: 100%;
  cursor: pointer;
}
.valuetestonline .seeDetail .topBackPart .detailTitle .showContPart .showTitle {
  width: 40%;
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 26px;
}
.valuetestonline .seeDetail .topBackPart .detailTitle .showContPart .showCont {
  width: 400px;
  /* margin-left: -50%; */
  margin: 0px auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  position: absolute;
  background-color: #fff;
  z-index: 999;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  box-shadow: 0px 9px 20px 0px rgba(92, 92, 92, 0.1);
  cursor: pointer;
  /* margin-left: -50%; */
}
.valuetestonline
  .seeDetail
  .topBackPart
  .detailTitle
  .showContPart
  .showCont
  li {
  width: 50%;
  font-size: 12px;
  color: #ccc;
  line-height: 30px;
  text-align: left;
  /* padding-left: 5px; */
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  /* margin: 0 2%; */
}
.valuetestonline .seeDetail .sortSearch {
  width: 80%;
  margin: 0 auto;
  background: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  padding: 12px 20px;
}
.valuetestonline .seeDetail .sortSearch .search {
  height: 40px;
  width: 33%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-left: 4%;
}
.valuetestonline .seeDetail .sortSearch .search input {
  outline: none;
  border: 1px solid #ccc;
  text-align: left;
  padding-left: 10px;
  width: 80%;
  color: #8a8a8a;
  font-size: 12px;
}
.valuetestonline .seeDetail .sortSearch .search .searchBtn {
  height: 40px;
  width: 20%;
  line-height: 40px;
  background-color: #158dd3;
  text-align: center;
  color: #fff;
  font-size: 14px;
}
.valuetestonline .seeDetail .tabList {
  width: 80%;
  margin: 0 auto;
  height: 60px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  background-color: #158dd3;
  padding: 0 20px;
}
.valuetestonline .seeDetail .tabList li {
  font-weight: 600;
  font-size: 14px;
  height: 60px;
  line-height: 60px;
  text-align: left;
  width: 5.5%;
  color: #fff;
  /* background-color: #158DD3; */
}
.valuetestonline .seeDetail .contList {
  width: 80%;
  margin: 0 auto;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  /* margin-bottom: 1%; */
  background-color: #fff;
  padding: 10px 20px;
}
.valuetestonline .seeDetail .contList:hover {
  background-color: #eaf2fe;
}
.valuetestonline .seeDetail .contList li {
  font-size: 12px;
  height: 40px;
  line-height: 40px;
  text-align: left;
  width: 5.5%;
  /* background-color: #fffbfb; */
}
.valuetestonline .el-collapse-item__header {
  font-size: 16px !important;
  border-bottom: 1px solid #fff;
  padding-left: 20px;
}
.valuetestonline .el-button--primary {
  color: black;
  background-color: #fff;
  border: 1px solid #ccc;
}
.valuetestonline
  .el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  /* background-color: #158DD3;
  color: #fff; */
  color: black;
  background-color: #fff;
}
.valuetestonline .el-button--primary:focus,
.valuetestonline .el-button--primary:hover {
  /* background: #158DD3;
  border-color: #158DD3;
  color: #fff; */
  color: black;
  background-color: #fff;
  border: 1px solid #ccc;
}
.valuetestonline .onlyLef {
  position: relative;
  width: 55%;
}
.valuetestonline .onlyRig {
  position: relative;
  width: 38%;
  /* background-color: pink !important; */
  margin-top: 8%;
  margin-right: 3%;
  background-color: rgba(255, 255, 255, 0.6) !important;
}
.valuetestonline .loginPart .newDiv {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* background-color: purple; */
}
.valuetestonline .loginPart .newDiv .newDivLeft {
  /* display: flex;
  flex-direction: row;
  justify-content: flex-start; */
  font-size: 14px;
  width: 150px;
  position: relative;
  height: 18px;
}
.valuetestonline .loginPart .newDiv .newDivLeft input {
  width: 10px;
  height: 10px;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}
.valuetestonline .loginPart .newDiv .newDivLeft p {
  position: absolute;
  top: 50%;
  left: 15px;
  transform: translateY(-50%);
}
.valuetestonline .seeDetail .el-pagination {
  white-space: nowrap;
  padding: 2px 5px;
  color: #303133;
  font-weight: 700;
  width: 80%;
  margin: 0 auto;
  background-color: #fff;
  padding: 32px 20px;
  margin-bottom: 35px;
}
.valuetestonline .changeDetailBgcColor {
  background: rgba(249, 250, 252, 1) !important;
}
.valuetestonline #lineDiv {
  width: 80%;
  margin: 0 auto;
  height: 1px;
  border-top: 1px solid #f1f1f1;
}
.valuetestonline .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: 1px solid #158dd3;
  border-right: 0;
}
/* .valuetestonline .el-tabs__item{
border-right: 1px solid #158DD3;
} */
/* .valuetestonline .el-tabs__item {
    border-right: 1px solid #158DD3;
    color: #158DD3;
} */
.valuetestonline .tabs__header .el-tabs__item:last-child {
  padding-right: 20px !important;
  border-radius: 6px !important;
  margin-right: 10px !important;
  /* border: 1px solid #158DD3!important; */
}
/* .valuetestonline .el-tabs--card > .el-tabs__header .el-tabs__item {
  border-bottom: 0;
} */
.valuetestonline .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: 0;
  border-right: 0;
}
.valuetestonline .el-tabs--card > .el-tabs__header {
  border-bottom: 0;
}

.valuetestonline .el-tabs--card > .el-tabs__header {
  border-radius: 4px;
  /* border-left: 1px solid #158DD3; */
}
.valuetestonline .lb {
  background-color: #fff;
  /* margin-top: 20px; */
  position: relative;
  /* top: 20px; */
  border-bottom: 1px solid #ccc;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  z-index: 999;
  box-shadow: 0px 0px 20px 0px rgba(92, 92, 92, 0.1);
  line-height: 26px;
  font-size: 14px;
  text-align: center;
  padding: 10px 0;
  width: 400px;
  /* margin-left: -50% */
}
.valuetestonline
  .seeDetail
  .topBackPart
  .detailTitle
  .showContPart
  .showCont
  li {
  padding: 10px 20px;
  box-sizing: border-box;
}
.noData {
  width: 100%;
  height: 20vh;
  font-size: 22px;
  line-height: 20vh;
  font-weight: 600;
  text-align: center;
}
.el-tabs__item {
  box-sizing: content-box;
}
.valuetestonline .el-tabs--card > .el-tabs__header .el-tabs__item {
  /* border-bottom: 0; */
  /* background-color: pink; */
  margin-right: 10px;
  /* margin: 0 10px; */
  border: 1px solid #158dd3;
  border-radius: 4px;
  z-index: 999;
  color: #158dd3;
  border-left: 1px solid #158dd3 !important;
}
.valuetestonline .el-submenu__title {
  font-size: 16px !important;
}
/* .valuetestonline .addressDiv {
  width: 80%;
  margin: 0 auto;
  font-size: 12px;
  color: gray;
  padding: 32px 20px;
} */
/* timeLi':''||index==1?'sortLi */
.timeLi {
  width: 11.5% !important;
}
.sortLi {
  width: 11.55% !important;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
/* <div class="topTitleDiv">
        <div class="topTitleDivLef">电磁阀在线测试查询分类</div>
        <ul class="topTitleDivRig">
          <li>在线测试查询</li>
          <li>历史测试查询</li>
          <li>
            <el-dropdown>
              <span class="el-dropdown-link">
                专项测试查询<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>黄金糕</el-dropdown-item>
                <el-dropdown-item>狮子头</el-dropdown-item>
                <el-dropdown-item>螺蛳粉</el-dropdown-item>
                <el-dropdown-item disabled>双皮奶</el-dropdown-item>
                <el-dropdown-item divided>蚵仔煎</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown></li>
        </ul>
      </div> */
.topTitleDiv {
  width: 70%;
  margin-left: 10%;
  /* background-color: pink; */
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 40px;
  position: relative;
}
.arrowIcon {
  position: absolute;
  top: 35px;
  left: 521px;
  width: 12px;
  height: 12px;
  /* background-color: #158DD3; */
  background-color: #fff;
  transform: rotate(45deg);
  z-index: 0;
  box-shadow: 0px 9px 20px 0px rgba(41, 41, 41, 0.1);
  visibility: hidden;
}
.bottomUl {
  /* width: 200px; */
  position: absolute;
  top: 40px;
  left: 516px;
  padding: 10px 10px;
  /* background-color: pink; */
  box-shadow: 0px 9px 20px 0px rgba(92, 92, 92, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  z-index: 9999;
  background-color: #fff;
  visibility: hidden;
  /* padding-left: 10px; */
}
.bottomUl li {
  width: 100%;
  margin: 0 auto;
  text-align: left;
  font-size: 12px;
  color: #666;
  /* background-color: green; */
  /* padding: 0 20px; */
  cursor: pointer;
  /* padding:0 10px; */
  text-indent: 1em;
}
.bottomUl li:hover {
  background-color: #158dd3;
  color: #fff;
  font-size: 12px;
}
/* .actInd {
  background-color: #158DD3!important;
  color: #fff!important;
  font-size: 12px!important;
} */
.topTitleDivRig > .hoves:hover .bottomUl,
.topTitleDivRig > .hoves:hover .arrowIcon {
  visibility: visible;
}
/* <ul class="bottomUl">
    <li v-for="(val,index) in testList" :key="index" @click.native="changeType(index)">{{val.specialInstructions }}</li>
</ul> */
.topTitleDivLef {
  height: 40px;
  line-height: 40px;
  /* background-color: #158DD3; */
  font-weight: 600;
  font-size: 14px;
}
.topTitleDivRig {
  font-size: 14px !important;
  /* background-color: yellow; */
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-left: 30px;
}
.topTitleDivRig li {
  line-height: 40px;
  margin-right: 50px;
  cursor: pointer;
}
.topTitleDivRig .el-dropdown {
  height: 40px !important;
  /* background-color: rgba(0, 128, 0, 0.219); */
}
.topTitleDivRig .el-dropdown-link {
  cursor: pointer;
  height: 40px;
}
.topTitleDivRig .el-dropdown-link {
  cursor: pointer;
  color: #666;
  font-size: 15px;
  display: block;
  margin: 0 auto !important;
  line-height: 40px;
}
.colorLi {
  color: #fff !important;
  background-color: #158dd3 !important;
  padding: 0 10px;
}
.colorLi .el-dropdown-link {
  color: #fff !important;
}
.textLeft {
  text-align: left !important;
}
.topTitleDivRig li .el-dropdown-menu {
  top: 300px !important;
  left: 300px !important;
}
.index-2 {
  cursor: pointer;
}
.newC {
  background-color: #158dd3 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/valuetestonline_smp.vue